import { ReactNode } from 'react';

import { useIsBreakpoint } from 'providers/WindowSize';

import { ResponsiveBreakpoint } from 'styles';

interface ResponsiveRenderProps {
  children?: never;
  breakPoint?: ResponsiveBreakpoint;
  responsiveContent: ReactNode;
  defaultContent: ReactNode;
}

export function ResponsiveRender({
  breakPoint = 'PHONE',
  defaultContent,
  responsiveContent,
}: ResponsiveRenderProps) {
  const passedBreakpoint = useIsBreakpoint(breakPoint);

  return <>{passedBreakpoint ? responsiveContent : defaultContent}</>;
}
